import React, { useCallback } from 'react';

import SingleSelectFilter from '@/components/FilterManager/SingleSelectFilter';

import { SingleSelectFilterContainerProps } from './types';

function SingleSelectFilterContainer({
  clearable = false,
  filterId,
  filter,
  setFilter,
  items,
  defaultPlaceholder,
  operators,
  selectedOperator,
  defaultSelectedValue,
  appearance,
}: SingleSelectFilterContainerProps) {
  const filterValue = (filter[filterId] || defaultSelectedValue) as string | undefined;
  const selectedData = items.filter((item) => item.value === filterValue);
  const selectedLabels = selectedData.map((item) => item.label);
  const selectedValues = selectedData.map((item) => item.value);

  const onItemClick = useCallback(
    (value: string) => {
      setFilter({
        ...filter,
        [filterId]: value,
      });
    },
    [filter, filterId, setFilter],
  );

  return (
    <SingleSelectFilter
      appearance={appearance}
      clearable={clearable}
      defaultPlaceholder={defaultPlaceholder}
      defaultSortBy={filterValue}
      filterId={filterId}
      items={items}
      operators={operators}
      selectedItems={selectedLabels}
      selectedOperator={selectedOperator}
      selectedValues={selectedValues}
      onChange={onItemClick}
    />
  );
}

export default SingleSelectFilterContainer;
